import Store from 'react-store';
import { gofor } from '@fiverr-private/futile';

const _pendingRequests = {},
    collUrl = '/collection_items',
    collHashUrl = '/collections/hash',
    CollectionStore = Store.extend({

        serializeJson(ary) {
            return Object.keys(ary).map((key) => {
                if (Array.isArray(ary[key])) {
                    const arrayParts = [];
                    for (let i = 0; i< ary[key].length; i++) {
                        arrayParts.push(`${encodeURIComponent(`${key}[]`)}=${encodeURIComponent(ary[key][i])}`);
                    }
                    return arrayParts.join('&');
                }
                return `${encodeURIComponent(key)}=${encodeURIComponent(ary[key])}`;
            }).join('&');
        },

        getCollections(hearts) {
            if (hearts.length < 1) {
                return {};
            }

            _pendingRequests[collHashUrl] = true;

            return gofor(`${collHashUrl}?${this.serializeJson({gigs: hearts})}`, {
                method: 'GET',
                headers: {
                    'Accept': 'text/javascript'
                }
            }).then((response) => response.ok && response.json()).then((data) => {
                delete _pendingRequests[collHashUrl];
                return data;
            });
        },

        toggleFavorite(type, gigId, collection) {
            if (!gigId || !collection) {
                return;
            }

            const params = {gig_id: gigId, collection},
                formData = Object.keys(params).map((key) => `${encodeURIComponent(key)}=${encodeURIComponent(params[key])}`).join('&');

            _pendingRequests[collUrl] = true;

            return gofor(collUrl, {
                method: type,
                headers: {
                    'Accept': 'text/javascript',
                    'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
                },
                body: formData
            }).then(() => {
                delete _pendingRequests[collUrl];
                return 'success';
            }).catch((error) => {
                throw error;
            });
        },

        newCollection(gigId, collection) {
            if (!gigId || !collection) {
                return;
            }

            const params = {gig_id: gigId, collection},
                formData = Object.keys(params).map((key) => `${encodeURIComponent(key)}=${encodeURIComponent(params[key])}`).join('&');

            _pendingRequests[collUrl] = true;

            return gofor(collUrl, {
                method: 'POST',
                headers: {
                    'Accept': 'text/javascript',
                    'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
                },
                body: formData
            }).then(() => {
                delete _pendingRequests[collUrl];
                return 'success';
            }).catch((response) => {
                const error = response.error();

                delete _pendingRequests[collUrl];
                return error && error.responseText ? JSON.parse(error.responseText).error : 'We\'re sorry, something went wrong';
            });
        }
    });

export default CollectionStore;



// WEBPACK FOOTER //
// ./src/store/collection/index.js